module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_opinions_trump-voters-will-not-like-what-happens-next_2016_11_09_e346ffc2-a67f-11e6-8fc0-7be8f848c492_story.html_plot.ceab9d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_opinions_trump-voters-will-not-like-what-happens-next_2016_11_09_e346ffc2-a67f-11e6-8fc0-7be8f848c492_story.html_plot.png
// module id = 439
// module chunks = 0